/**
 * Scorecard Tab Wrapper
 * Wrapper component to be used in InterviewTabs
 * Handles feature flag and visibility mode switching
 */

import React from 'react';
import { AllScorecardWithVisibility } from './AllScorecardWithVisibility';
import { AfterInterviewScorecard } from '../../AfterInterviewScorecard';
import { type GroupedScorecards, type ScorecardVisibilityMode } from '../types';
import { useKFlags } from '@/hooks/use-k-flags';
import { type InterviewType } from '@/types/interview';

interface AllScorecardTabWrapperProps {
  interview: InterviewType;
  interviewId?: string | number;
  scorecardVisibilityMode?: ScorecardVisibilityMode;
  apiGroupedScorecards?: GroupedScorecards;
  hasCurrentUserSubmitted: boolean;
  tabId: string;
  refetchScorecardVisibility: () => void;
}

export const AllScorecardTabWrapper = React.memo(
  function AllScorecardTabWrapper({
    interview,
    apiGroupedScorecards,
    scorecardVisibilityMode,
    hasCurrentUserSubmitted,
    tabId,
    refetchScorecardVisibility,
  }: AllScorecardTabWrapperProps) {
    const { feScorecardVisibility } = useKFlags();
    const visibilityMode: ScorecardVisibilityMode =
      scorecardVisibilityMode || 'never';

    // const filteredGroupedScorecards: GroupedScorecards | undefined =
    //   useMemo(() => {
    //     if (!apiGroupedScorecards) {
    //       return undefined;
    //     }
    //     if (tabId === 'all_scorecards') {
    //       debugger;
    //       let currentInterview: ScorecardItem[] = [];
    //       // if (interview?.can_edit) {
    //       //   currentInterview = (
    //       //     apiGroupedScorecards.currentInterview ?? []
    //       //   ).filter((sc) => !sc.is_current);
    //       // } else {
    //       currentInterview = (apiGroupedScorecards.currentInterview ?? []).filter(
    //         (sc) => sc.reviewer.id !== currUser?.id
    //       );
    //       // }

    //       return {
    //         currentInterview,
    //         history: apiGroupedScorecards.history ?? [],
    //       };
    //     }
    //     return apiGroupedScorecards;
    //   }, [apiGroupedScorecards, currUser?.id, tabId, interview?.can_edit]);

    // If feature is disabled, use the original component
    if (!feScorecardVisibility) {
      return <AfterInterviewScorecard interview={interview} />;
    }

    // Use new visibility-aware component
    return (
      <AllScorecardWithVisibility
        interview={interview}
        apiGroupedScorecards={apiGroupedScorecards}
        visibilityMode={visibilityMode}
        hasCurrentUserSubmitted={hasCurrentUserSubmitted}
        tabId={tabId}
        refetchScorecardVisibility={refetchScorecardVisibility}
      />
    );
  }
);
